// src/icons/svgs/align-text-right.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgAlignTextRight = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 18, fill: "none", viewBox: "0 0 24 18", ref, ...props, children: /* @__PURE__ */ jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.363.818a.818.818 0 0 0 0 1.636h21.33a.818.818 0 1 0 0-1.636zm4.74 4.91a.818.818 0 1 0 0 1.636h16.59a.818.818 0 1 0 0-1.637zM.545 11.454c0-.452.366-.819.818-.819h21.33a.818.818 0 1 1 0 1.637H1.363a.82.82 0 0 1-.818-.819m5.558 4.09a.818.818 0 1 0 0 1.637h16.59a.818.818 0 0 0 0-1.637z", clipRule: "evenodd" }) });
var ForwardRef = forwardRef(SvgAlignTextRight);
var align_text_right_default = ForwardRef;
export {
  align_text_right_default as TextAlignRight
};
